import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AccountsService } from 'src/app/feature-modules/accounts/services/accounts.service';

@Component({
    selector: 'app-loan-redirect',
    templateUrl: './loan-redirect.component.html',
    styleUrls: ['./loan-redirect.component.scss'],
    standalone: false
})
export class LoanRedirectComponent implements OnInit {
  constructor(private readonly accountsService: AccountsService, private readonly router: Router) {}

  ngOnInit(): void {
    const loanUrl = localStorage.getItem('bestegg_loan_url');

    if (loanUrl) {
      this.accountsService.navigateToPersonalLoan({ url: loanUrl, id: null });
    } else {
      this.router.navigate(['/customer-hub']);
    }
  }
}
